import styled           from 'styled-components';

import { cssFlexRow,
         themeColors,  
         themeTypos,
         Typo,
         typoAsCSS    } from 'src/providers/theme/shared';



type StatusLookAndFeel = {
  height: number;
  paddings: number[];
  labelTypo: Typo;
  
  borderColor: string;
  borderRadius: number;
  backgroundColor: string;
  textColor: string;
}

const status_base = {
  height: 18,
  paddings: [0, 6],
  labelTypo: themeTypos.GRTSKREG_W400_S10_LH12,
  borderRadius: 0,
}

const status_redoutline: StatusLookAndFeel = {
  ...status_base,

  borderColor: themeColors.AccentRed1,
  backgroundColor: themeColors.PrimaryWhite,
  textColor: themeColors.AccentRed1,
}

const status_blueoutline: StatusLookAndFeel = {
  ...status_base,

  borderColor: themeColors.AccentBlue2,
  backgroundColor: themeColors.PrimaryWhite,
  textColor: themeColors.AccentBlue2,
}

const status_grayfill: StatusLookAndFeel = {
  ...status_base,

  borderColor: themeColors.SecondaryGray4,
  backgroundColor: themeColors.SecondaryGray4,
  textColor: themeColors.PrimaryWhite,
}

const status_capsule_base = {
  height: 28,
  paddings: [9, 10],
  labelTypo: themeTypos.GRTSKREG_W400_S10_LH12,
  borderRadius: 9999,
}

const status_redCapsule: StatusLookAndFeel = {
  ...status_capsule_base,

  borderColor: themeColors.BorderRed,
  backgroundColor: themeColors.PrimaryWhite,
  textColor: themeColors.TextAccentRed100,
}

const status_blueCapsule: StatusLookAndFeel = {
  ...status_capsule_base,

  borderColor: themeColors.BorderBlue,
  backgroundColor: themeColors.PrimaryWhite,
  textColor: themeColors.TextAccentBlueCobolt100,
}

const status_grayCapsule: StatusLookAndFeel = {
  ...status_capsule_base,

  borderColor: themeColors.SecondaryGray4,
  backgroundColor: themeColors.PrimaryWhite,
  textColor: themeColors.TextNeutralText100,
}

export type StatusVariants =  'redoutline' | 
                              'blueoutline' | 
                              'grayfill' | 
                              'redCapsule' |
                              'blueCapsule' |
                              'grayCapsule';

export const status_variants: Map<StatusVariants, StatusLookAndFeel> = 
  new Map<StatusVariants, StatusLookAndFeel>([
    ['redoutline', status_redoutline],
    ['blueoutline', status_blueoutline],
    ['grayfill', status_grayfill],
    ['redCapsule', status_redCapsule],
    ['blueCapsule', status_blueCapsule],
    ['grayCapsule', status_grayCapsule],
  ]);

export const Container = styled.div<{
  lookAndFeel: StatusLookAndFeel;
}>`
  ${cssFlexRow}
  align-items: center;
  width: fit-content;
  height: ${(args) => args.lookAndFeel.height}px;
  padding: ${(args) => args.lookAndFeel.paddings[0]}px ${(args) => args.lookAndFeel.paddings[1]}px;

  border: 1px solid ${(args) => args.lookAndFeel.borderColor};
  border-radius: ${(args) => args.lookAndFeel.borderRadius}px;
  background-color: ${(args) => args.lookAndFeel.backgroundColor};
  color: ${(args) => args.lookAndFeel.textColor};

  ${(args) => typoAsCSS(args.lookAndFeel.labelTypo)}
`
